// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"109":"2af72d31","142":"c731b346","240":"81c7f72f","467":"0e216121","844":"0d707164","864":"e71d43b4"}[chunkId] + ".css";
};